import Form, { FormProps } from "../../../ui-components/forms/form/Form";
import { CreateLinkFormNumberProps } from "./NumberField";
import { CreateLinkFormRadioButtonProps } from "./RadioButtonField";

export type CreateLinkFormProps = CreateLinkFormNumberProps &
  CreateLinkFormRadioButtonProps;
export const CreateLinkTypedForm: (
  props: FormProps<CreateLinkFormProps>
) => JSX.Element = props => Form<CreateLinkFormProps>(props);
